import { useQuery } from '@tanstack/react-query';
import type { CpGpMatchedProduct } from '../../../models/Coupang';
import { cpGpMatchClient } from '../../../infrastructure/CpGpMatchClient';

// SSD-4938: seed first paint with placeholderData, NOT initialData — initialData is cached as
// fresh so staleTime:5min suppressed the on-mount refetch (stale route-state shown for ~5 min).
export const useCpGpMatch = (
  cpProductId?: string,
  cpItemId?: string,
  initialMatch?: CpGpMatchedProduct,
) =>
  useQuery({
    queryKey: ['cpGpMatch', cpProductId, cpItemId],
    queryFn: async () => {
      if (!cpProductId || !cpItemId) {
        throw new Error('Invalid product URL. Missing product identifiers.');
      }
      const response = await cpGpMatchClient.getMatchByCpProductAndItemId(cpProductId, cpItemId);
      if (!response.success || !response.match) {
        throw new Error(response.message || 'Product not found in the matched products database.');
      }
      return response.match as CpGpMatchedProduct;
    },
    ...(initialMatch ? { placeholderData: initialMatch } : {}),
    enabled: Boolean(cpProductId && cpItemId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
